<template>
  <div>
      <div :style="{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'space-between',
          width: '100%'
      }">
        <div :style="{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          textAlign: 'left',
          width: '100%'
        }">

            <div style="margin-top: -10px;">
                <el-radio 
                    :disabled="($store.getters.getUserInformation.staff_id !== $store.getters.getTaskDataProps.created_by_staff_id) && $store.state.tasks.props.id>0" 
                    :label="0" 
                    v-model="$store.state.tasks.props.priority">Normal</el-radio>
                <el-radio :disabled="($store.getters.getUserInformation.staff_id !== $store.getters.getTaskDataProps.created_by_staff_id) && $store.state.tasks.props.id>0" :label="1" v-model="$store.state.tasks.props.priority">Medium</el-radio>
                <el-radio :disabled="($store.getters.getUserInformation.staff_id !== $store.getters.getTaskDataProps.created_by_staff_id) && $store.state.tasks.props.id>0" :label="2" v-model="$store.state.tasks.props.priority">Urgent</el-radio>
            </div>

            <div style="margin-top: 20px; width: 100%;">
                <span type="label">Task Title</span>
                
                <br>
                <el-input :disabled="($store.getters.getUserInformation.staff_id !== $store.getters.getTaskDataProps.created_by_staff_id) && $store.state.tasks.props.id>0" @focus="$event.target.select()"
                    v-model="$store.state.tasks.props.title"
                    size="small"
                    :style="{width: isMobileDevice ? '100%' : '400px'}">
                    <template slot="prepend" v-if="$store.state.tasks.props.id === 0">
                        <span v-if="$store.getters.getCustomerMasterDataProps.id>0 
                                && (getCurrentPath.indexOf('salesorders')>=0 || getCurrentPath.indexOf('customers')>=0 || getCurrentPath.indexOf('productionworkorders')>=0)">
                            {{$store.state.tasks.props.title_prefix = $store.getters.getCustomerMasterDataProps.customer_name}}
                        </span>
                        <span v-else-if="$store.getters.getGenericContactDataProps.id>0 && getCurrentPath.indexOf('genericcontacts')>=0">
                            {{$store.state.tasks.props.title_prefix = $store.getters.getGenericContactDataProps.full_name}}
                        </span>
                        
                    </template>
                    <template slot="prepend" v-else-if="$store.state.tasks.props.id > 0 && $store.state.tasks.props.title_prefix.length>0">
                        {{$store.state.tasks.props.title_prefix}}
                    </template>
                </el-input>
                
            </div>

            <div style="margin-top: 10px; width: 100%;">
                <el-radio v-model="$store.state.tasks.props.task_type" :label="0">
                    Task
                </el-radio>

                <el-radio v-model="$store.state.tasks.props.task_type" :label="1">
                    Appointment
                </el-radio>
            </div>

            <div style="margin-top: 10px; width: 100%;">
                <span type="label">Task Date{{$store.state.tasks.props.task_type === 0 ? '' : '/Time'}}</span>
                <br>
                <el-date-picker
                    v-if="$store.state.tasks.props.task_type === 0"
                    :disabled="($store.getters.getTaskDataProps.status > 0 || $store.getters.getUserInformation.staff_id !== $store.getters.getTaskDataProps.created_by_staff_id) && ($store.state.tasks.props.id>0 && !$store.state.tasks.props.revised)"
                    :type="'date'"
                    v-model="$store.state.tasks.props.task_date"
                    :style="{width: isMobileDevice ? '100%' : '400px'}"
                    :value-format="'yyyy-MM-dd'"
                    :format="'MMM dd yyyy'">
                </el-date-picker>
                <el-date-picker
                    v-else
                    :disabled="($store.getters.getTaskDataProps.status > 0 || $store.getters.getUserInformation.staff_id !== $store.getters.getTaskDataProps.created_by_staff_id) && $store.state.tasks.props.id>0 && !$store.state.tasks.props.revised"
                    :type="'datetime'"
                    v-model="$store.state.tasks.props.task_time"
                    :style="{width: isMobileDevice ? '100%' : '400px'}"
                    :value-format="'yyyy-MM-dd HH:mm:ss'"
                    :format="'MMM dd yyyy hh:mm a'">
                </el-date-picker>
                <br>
                <el-checkbox style="margin-top: 10px;" v-if="$store.state.tasks.props.id>0 
                        && $store.getters.getUserInformation.staff_id 
                            === $store.getters.getTaskDataProps.created_by_staff_id" 
                            v-model="$store.state.tasks.props.revised">
                    Revise Task Date
                </el-checkbox>
                <span style="color: red; font-size: 11px;">
                    {{$store.state.tasks.props.revision_count>0 ? 'Revised '+$store.state.tasks.props.revision_count+' times.' : ''}}
                </span>

            </div>
            
            <div style="margin-top: 10px; width: 100%;">
                <span type="label">Description</span>
                <br>
                <el-input 
                    :disabled="($store.getters.getUserInformation.staff_id !== $store.getters.getTaskDataProps.created_by_staff_id) && $store.state.tasks.props.id>0" 
                    @focus="$event.target.select()"
                    v-model="$store.state.tasks.props.description"
                    type="textarea"
                    size="small"
                    rows="5"
                    :style="{width: isMobileDevice ? '100%' : '400px'}">
                </el-input>
            </div>

            <div style="margin-top: 20px; width: 100%;">
                <span type="label">Category</span>
                <br>
                <div>
                    <el-select 
                        :disabled="($store.getters.getUserInformation.staff_id !== $store.getters.getTaskDataProps.created_by_staff_id) && $store.state.tasks.props.id>0"
                        size="small"
                        v-model="$store.state.tasks.props.category_id" filterable 
                        :style="{width: isMobileDevice ? '100%' : '400px', textAlign: 'left'}">
                        <el-option
                            v-for="(data, index) in $store.getters.getTaskCategoryList"
                            :key="index"
                            :label="data.category_name"
                            :value="data.id">
                            <span style="float: left" v-html="data.category_name"></span>
                        </el-option>
                    </el-select>
                </div>
            </div>

            <div style="margin-top: 10px; width: 100%;">
                <span type="label">Assigned To</span>
                <br>
                <el-autocomplete
                    v-if=" $store.state.tasks.props.id === 0"
                    class="inline-input"
                    :disabled="($store.getters.getUserInformation.staff_id !== $store.getters.getTaskDataProps.created_by_staff_id) && $store.state.tasks.props.id>0" size="small"
                    v-model="staff_name" 
                    :fetch-suggestions="queryStaffSearch"
                    :style="{width: isMobileDevice ? '100%' : '400px', textAlign: 'left'}"
                    :trigger-on-focus="true"
                    @select="loadSelectedStaffName"
                ></el-autocomplete>
                <el-select 
                    v-else
                    :disabled="($store.getters.getUserInformation.staff_id !== $store.getters.getTaskDataProps.created_by_staff_id) && $store.state.tasks.props.id>0" size="small"
                    v-model="$store.state.tasks.props.assigned_to_staff_id" 
                    filterable 
                    :style="{width: isMobileDevice ? '100%' : '400px', textAlign: 'left'}">
                    <el-option :value="0" label="Admin">
                        <span :style="'float: left;'" v-html="'Admin'"></span>
                    </el-option>
                    <el-option
                        v-for="(data, index) in $store.getters.getEmployeeMasterList.filter(t => t.active)"
                        :key="index"
                        :label="data.id === $store.getters.getUserInformation.staff_id ? 'Self' : data.staff_name"
                        :value="data.id">
                        <span 
                            :style="'float: left; '+(data.id === $store.getters.getUserInformation.staff_id ? 'font-weight: bold; color: red;' : '')+''" 
                            v-html="data.id === $store.getters.getUserInformation.staff_id ? 'Self' : data.staff_name"></span>
                    </el-option>
                </el-select>
            </div>

            
            <div style="margin-top: 10px; width: 100%;">
                <span type="label">Remarks</span>
                <br>
                <el-input :disabled="($store.getters.getUserInformation.staff_id !== $store.getters.getTaskDataProps.created_by_staff_id) && $store.state.tasks.props.id>0" @focus="$event.target.select()"
                    v-model="$store.state.tasks.props.internal_notes"
                    size="small"
                    :style="{width: isMobileDevice ? '100%' : '400px'}">
                </el-input>
            </div>
            <div style="margin-top: 10px;">
                <UploadFile 
                    @uploaded="$store.state.tasks.props.document=$event"
                    :image_path="$store.state.tasks.props.document"
                    :image_width="75"
                    :allow_pdf="true"
                    :file_dialog_id="'task_file_upload'"
                    :button_style="'width: 100px; top: 5px; position: relative;'"
                />
            </div>  

            <div style="margin-top: 20px;">
                <el-radio
                    :disabled="!($store.getters.getUserInformation.staff_id === $store.getters.getTaskDataProps.assigned_to_staff_id)"
                    :label="1"
                    v-model="$store.state.tasks.props.status"
                    size="small">
                    WIP
                </el-radio>
                <el-radio
                    :disabled="!($store.getters.getUserInformation.staff_id === $store.getters.getTaskDataProps.assigned_to_staff_id)"
                    :label="2"
                    v-model="$store.state.tasks.props.status"
                    size="small">
                    Completed
                </el-radio>
                <br><br>
                <el-radio
                    :label="3"
                    :disabled="!($store.getters.getUserInformation.staff_id === $store.getters.getTaskDataProps.created_by_staff_id)"
                    v-model="$store.state.tasks.props.status"
                    size="small">
                    Rejected
                </el-radio>
                <el-radio
                    :label="4"
                    :disabled="!($store.getters.getUserInformation.staff_id === $store.getters.getTaskDataProps.created_by_staff_id)"
                    v-model="$store.state.tasks.props.status"
                    size="small">
                    Approved
                </el-radio>
            </div>



            <div style="margin-top: 20px; width: 100%; text-align: left;">
                    <el-button @click="submitBalance" size="small" type="primary">
                        Submit
                    </el-button>
            </div>    
            
        </div>   
      </div>
  </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect';

export default {
    data() {
        return {
            bank_id: null, 
            store_id: null, 
            transaction_date: new Date(), 
            amount: 0,
            staff_name: ''
        }
    },
    computed: {
        isMobileDevice() {
            return isMobile
        },
        getCurrentPath() {
            return this.$router.currentRoute.fullPath
        },
        getStaffNameList() {
            let returnList = [{
                value: "Admin",
                id: 0
            }]

            this.$store.getters.getEmployeeMasterList.filter(t => t.active).forEach(element => {
                returnList.push({
                    value: element.id === this.$store.getters.getUserInformation.staff_id ? 'Self' : element.staff_name,
                    id: element.id
                })
            })

            return returnList
        }
    },
    methods: {
        loadSelectedStaffName($event) {
            this.$store.state.tasks.props.assigned_to_staff_id = $event.id
            this.staff_name = $event.value
        },
        queryStaffSearch(queryString, cb) {
            var links = this.getStaffNameList;
            var results = queryString ? links.filter(this.createFilter(queryString)) : links;
            // call callback function to return suggestions
            cb(results);
        },
        createFilter(queryString) {
            return (link) => {
                return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            }
        },
        async submitBalance() {

            if(this.$store.state.tasks.props.title.length === 0) {
                this.$store.commit('displayMessageAlert', {message: 'Please mention title of the task', type: 'Error'})    
                return
            } else if(this.$store.state.tasks.props.description.length === 0) {
                this.$store.commit('displayMessageAlert', {message: 'Please describe the task', type: 'Error'})    
                return
            } else if(this.$store.state.tasks.props.category_id === null || (this.$store.state.tasks.props.category_id !== null && this.$store.state.tasks.props.category_id === 0)) {
                this.$store.commit('displayMessageAlert', {message: 'Please select the category of the task', type: 'Error'})    
                return
            }

            await this.$store.dispatch('submitTaskData', this.$store.state.tasks.props)
        }

    }
}
</script>

<style scoped>

    
</style>


// WEBPACK FOOTER //
// src/views/Tasks/TaskForm.vue